export default "__VITE_ASSET__B2wmqD4w__"